import { render, staticRenderFns } from "./Scenari.vue?vue&type=template&id=6bf0d65c&"
import script from "./Scenari.vue?vue&type=script&lang=js&"
export * from "./Scenari.vue?vue&type=script&lang=js&"
import style0 from "./Scenari.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports